// METROMIDLANDS FINANCIAL PLANNERS SCRIPTS
( function($) {

$(document).ready(function() {


	//MENU
	$('.menuNavThirdLevelCurrent').parent().parent().addClass('menuNavSubLevelCurrent');
	$('.menuNavSubLevelCurrent').parent().parent().addClass('menuNavTopLevelCurrent');
	$('#menuNavItem22055 > a').click(function(event) {
		  event.preventDefault();
	});


	//INITIALIZE
	if($('#dataformContainer').length){
		$('.arrw').css('display','none');
	}
	$('.gallery-slide-image a, .gallery-slide-title a').click(function(event){event.preventDefault();});
	$('#redback').fadeTo(0, 0.5);


	//FADE EFFECTS
	$('#btn-client-login, #btn-our-process, #btn-our-process-hp, #btn-our-team, #btn-alliances, #btn-contact-us, #btn-strategies, #btn-service-offerings, #btn-testimonials, #btn-our-services, #btn-alliances-alt, #btn-contact-us-alt, #btn-strategies-alt, #btn-service-offerings-alt, #btn-service-offerings-alt-2, #btn-our-process-alt-2, #btn-newsletter, #btn-links, #btn-links-alt, #btn-forms-docs, #inner .col-left .accordion-process h3, #accordion h3, .newsletter img').mouseenter(function(){$(this).stop().fadeTo(200,0.7);});
	$('#btn-client-login, #btn-our-process, #btn-our-process-hp, #btn-our-team, #btn-alliances, #btn-contact-us, #btn-strategies, #btn-service-offerings, #btn-testimonials, #btn-our-services, #btn-alliances-alt, #btn-contact-us-alt, #btn-strategies-alt, #btn-service-offerings-alt, #btn-service-offerings-alt-2, #btn-our-process-alt-2, #btn-newsletter, #btn-links, #btn-links-alt, #btn-forms-docs, #inner .col-left .accordion-process h3, #accordion h3, .newsletter img').mouseleave(function(){$(this).stop().fadeTo(200,1);});
	$('#redback').mouseenter(function(){$(this).stop().fadeTo(200,1);});
	$('#redback').mouseleave(function(){$(this).stop().fadeTo(200,0.7);});


	//ACCORDION
	$('.services, .step').hide();
	$("h3").click(function(){
		var test = $(this).attr("id");
		$(this).next(".services, .step").slideToggle("1000")
		.siblings(".services:visible, .step:visible").slideUp("1000", function(){
			$('html,body').animate({scrollTop: $("#"+test).offset().top},'1000');
			});
		$(this).toggleClass("active");
		$(this).siblings("h3").removeClass("active");
	});

	//Open to correct item in accordion from home page service list
	var anchorVal = window.location.hash.split("#")[1];
	featureProject(anchorVal);

	 $('#banner .flexslider').flexslider({
	  controlNav: false,
	  directionNav: false,
	  useThumbImages: false
	 })



});

function featureProject(anchorVal) {
	switch(anchorVal) {
	case 'Wealth-Creation':
		$("h3").eq(0).addClass("active");
		$(".services, .step").eq(0).show();
		break;
	case 'Superannuation':
		$("h3").eq(1).addClass("active");
		$(".services, .step").eq(1).show();
	 	break;
	case 'Retirement-Planning-Strategies':
		$("h3").eq(2).addClass("active");
		$(".services, .step").eq(2).show();
	 	break;
	case 'Personal-Insurance':
		$("h3").eq(3).addClass("active");
		$(".services, .step").eq(3).show();
	 	break;
	}
}



//FLEXSLIDER
/*$(window).load(function(){
	$('#inner .flexslider').flexslider({
		directionNav:false,
		controlNav:false,
		keyboardNav:false,
		touchSwipe:false,
		randomize:true,
		start:function(slider){
			slider.pause();
		}
	});
	$('.flexslider').flexslider({
		directionNav:false,
		controlNav:false,
		keyboardNav:false,
		touchSwipe:false
	});
});*/
// Offcanvas Menu Layout
$(".offcanvas-header-menu > .menu-item-has-children > a").each(function () {
	var $linkContent = $(this).html();
	$(this).html(
		$linkContent +
			'<i class="fa fa-angle-down menu-item-angle-icon"></i>'
	);
});

$(
	".offcanvas-header-menu > .menu-item-has-children> .sub-menu > .menu-item-has-children > a"
).each(function () {
	var $subLinkContent = $(this).html();
	$(this).html(
		$subLinkContent +
			'<i class="fa fa-angle-down menu-item-angle-icon"></i>'
	);
});

$(".offcanvas-header-menu > .menu-item-has-children > .sub-menu").each(
	function () {
		//$(this).addClass('sub-menu--level-1');
		$(this).removeClass("sub-menu");
		$(this).wrap('<div class="sub-menu sub-menu--level-1"></div>');

		$(this)
			.parent()
			.find(".sub-menu")
			.each(function () {
				//$(".offcanvas-header-menu > .menu-item-has-children> .sub-menu > .menu-item > .sub-menu").each(function () {
				//$(this).addClass('sub-menu--level-2');
				$(this).removeClass("sub-menu");
				$(this).wrap(
					'<div class="sub-menu sub-menu--level-2"></div>'
				);
			});
	}
);

// Offcanvas functionality
$(".jsOffcanvasMenu").each(function () {
	var $body = $("body");
	var $offcanvasMenu = $(this);
	var $offcanvasBack = $offcanvasMenu.find(".jsOffcanvasBack");
	var $offcanvasClose = $offcanvasMenu.find(".jsOffcanvasClose");
	var $offcanvasToggler = $(".jsOffcanvasToggler");
	var $lastActive = false;

	function openOffcanvas() {
		$offcanvasMenu.toggleClass("is_active");
		$body.addClass("body--no-scroll");
	}

	// Close all open sub-menus and offcanvas-menu
	function closeOffcanvas() {
		$(".offcanvas-menu-wrapper .is_active").each(function () {
			{
				$(this).removeClass("is_active");
				$lastActive = false;
			}
		});

		$body.removeClass("body--no-scroll");
	}

	function hideBackBtn() {
		$offcanvasBack.removeClass("is_active");
	}

	function showBackBtn() {
		$offcanvasBack.addClass("is_active");
	}

		// Go to previous last active sub-menu or to the offcanvas-menu
		function goBackOffcanvas(el) {
			// el: the last active sub-menu
			el.removeClass("is_active");

			$lastActive =
				$(".offcanvas-menu-wrapper .sub-menu.is_active").length > 0
					? $(".offcanvas-menu-wrapper .sub-menu.is_active")
					: false;

			if (!$lastActive) {
				hideBackBtn();
			}
		}

		$offcanvasToggler.on("click", function (e) {
			e.preventDefault();
			openOffcanvas();
		});

		$offcanvasClose.on("click", function (e) {
			e.preventDefault();
			closeOffcanvas();
		});

		$offcanvasBack.on("click", function (e) {
			e.preventDefault();
			goBackOffcanvas($lastActive);
		});

		$(".offcanvas-menu .menu-item-has-children a i").on(
			"click",
			function (e) {
				e.preventDefault();

				$(this).parent().next().toggleClass("is_active");
				showBackBtn();
				$lastActive = $(this).parent().next();
			}
		);
	});
})(jQuery);
